import { Component, OnInit, ChangeDetectionStrategy, Input, ViewChild, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Criterio, NivelCriterio } from 'src/app/_models/meta';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { switchMap, tap, mergeMap, startWith, catchError, map, distinctUntilChanged } from 'rxjs/operators';
import { RetroalimentacionService } from '../_services/retroalimentacion.service';
import { of, Observable, Subscription } from 'rxjs';
import { MatRadioGroup } from '@angular/material/radio';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EstudioService } from '../../estudio.service';
import { AlumnoRetroalimentacion } from '../models/alumno-retroalimentacion';

@Component({
  selector: 'app-boton-criterio-group',
  standalone: false,
  templateUrl: './boton-criterio-group.component.html',
  styleUrls: ['../retroalimentacion.component.scss']
})
export class BotonCriterioGroupComponent implements OnInit, OnChanges, OnDestroy {

  @Input()
  alumnos$: Observable<AlumnoRetroalimentacion[]>;

  @Input()
  alumno: AlumnoRetroalimentacion;

  @Input()
  nivel: NivelCriterio;

  @Input()
  fecha$: Observable<string>;
  fecha: string;

  @Input()
  eventoUnidadID;

  @Input()
  view: string;

  @Input()
  mostrarAutoevaluacion$: Observable<boolean>;

  anteriorId: number;

  radioForm = new UntypedFormGroup({
    radio: new UntypedFormControl(null),
    save: new UntypedFormControl(false),
  });

  fechaSubscription: Subscription;
  radioFormSubscription: Subscription;
  alumnoSubscription: Subscription;

  constructor(
    private retroalimentacionService: RetroalimentacionService,
    private customAlertService: CustomAlertService,
    private snackBar: MatSnackBar,
    private estudioService: EstudioService) { }

  ngOnInit(): void {
    this.fechaSubscription = this.fecha$.subscribe(fecha => {
      this.fecha = fecha;
      this.actualizarRadioForm();
    });
    this.alumnoSubscription = this.alumnos$.pipe(map(data => {
      const current = data.find(item => item.id === this.alumno.id);
      return current ? current.criterios : false;
    })
    ).subscribe(res => {
      if (res) {
        this.alumno.criterios = res;
        this.actualizarRadioForm();
      }
    });

    this.radioFormSubscription = this.radioForm.valueChanges.pipe(
      mergeMap(data => {
        if (data.save === true) {
          if (data.radio === null) {
            if (this.anteriorId) {
              const anteriorIdTemp = this.anteriorId;
              this.anteriorId = 0;
              this.estudioService.cambiosEmit(this.alumno.id, anteriorIdTemp, this.alumno.unidadEventoMateriaId, 'delete');
              return this.retroalimentacionService.deleteEvaluacion(anteriorIdTemp,
                this.alumno.unidadEventoMateriaId, this.alumno.id).pipe(
                catchError(err => {
                  this.anteriorId = anteriorIdTemp;
                  this.estudioService.cambiosEmit(this.alumno.id, anteriorIdTemp,
                    this.alumno.unidadEventoMateriaId, 'create');
                  this.customAlertService.setCustomMessage({
                    tipo: 'error',
                    texto: `No ha sido posible guardar la evaluación. <br> Código de error: ${err.statusText}`
                  });
                  return of(true);
                })
              );
            } else {
              return of(true);
            }
          } else {
            const anteriorIdTemp = this.anteriorId;
            this.anteriorId = data.radio;
            const objetoEvaluacion = {
              criterioId: data.radio,
              alumnoId: this.alumno.id,
              unidadEventoMateriaId : this.alumno.unidadEventoMateriaId
            };
            this.estudioService.cambiosEmit(this.alumno.id, anteriorIdTemp, this.alumno.unidadEventoMateriaId, 'delete');
            this.estudioService.cambiosEmit(this.alumno.id, data.radio, this.alumno.unidadEventoMateriaId, 'create');
            return this.retroalimentacionService.setEstadoEvaluacionCriterio(objetoEvaluacion, 'post').pipe(
              catchError(err => {
                this.estudioService.cambiosEmit(this.alumno.id, data.radio, this.alumno.unidadEventoMateriaId, 'delete');
                if (this.anteriorId) {
                  this.estudioService.cambiosEmit(this.alumno.id, anteriorIdTemp,
                    this.alumno.unidadEventoMateriaId, 'create');
                }
                this.customAlertService.setCustomMessage({
                  tipo: 'error',
                  texto: `No ha sido posible guardar la evaluación. <br> Código de error: ${err.statusText}`
                });
                return of(true);
              })
            );
          }
        } else {
          return of(true);
        }
      })
   ).subscribe(
     res => {
       if (res !== true) {
        if (res) {
          this.estudioService.cambiosEmit(res.id, this.anteriorId, res.unidadEventoMateriaId, 'edit');
        }
        const respuesta = res ? `La evaluación fue guardada exitosamente.` : `La evaluación fue eliminada exitosamente.`;
        this.snackBar.open(respuesta, null, {duration: 2500});
      }
     },
     err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible guardar la evaluación. <br> Código de error: ${err.statusText}`
      });
     }
   );

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.alumno) {
      this.actualizarRadioForm();
    }
  }

  actualizarRadioForm() {
    this.radioForm.setValue({radio: null, save: false});
    this.alumno.criterios.forEach(criterio => {
      this.nivel.criterios.forEach(criterioNivel => {
        if (criterioNivel.id === criterio.criterioId) {
          this.anteriorId = criterio.criterioId;
          this.radioForm.setValue( {radio: criterio.criterioId, save: false});
        }
      });
    });
  }

  limpiarFormYGuardar() {
    if (this.radioForm.value.radio !== null) {
      this.radioForm.setValue({radio: null, save: true});
    }
  }

  ngOnDestroy(): void {
    if (this.fechaSubscription) {
      this.fechaSubscription.unsubscribe();
    }
    if (this.radioFormSubscription) {
      setTimeout(() => {
        this.radioFormSubscription.unsubscribe();
      }, 100)
    }
    if (this.alumnoSubscription) {
      this.alumnoSubscription.unsubscribe();
    }
  }

}
